class InviteLink {
  constructor(inviteLink) {
    const shareUrl = inviteLink.href;
    inviteLink.addEventListener("click", (e) => {
      e.preventDefault();
      if (navigator.share) {
        this.openNativeShareDialog(shareUrl);
      } else {
        this.copyLinkToClipboard(inviteLink, shareUrl);
      }
    });
  }

  openNativeShareDialog(shareUrl) {
    navigator.share({
      title: "Invite a friend",
      url: shareUrl,
    });
  }

  copyLinkToClipboard(inviteLink, shareUrl) {
    const originalButtonText = inviteLink.innerHTML;
    const copiedButtonText = "Link copied";
    if (navigator.clipboard) {
      navigator.clipboard.writeText(shareUrl).then(function () {
        inviteLink.innerHTML = copiedButtonText;
        setTimeout(function () {
          inviteLink.innerHTML = originalButtonText;
        }, 3000);
      });
    } else {
      window.prompt(
        "Copy the following address and share it with a friend!",
        shareUrl
      );
      return false;
    }
  }
}

export default InviteLink;
